import TextArea from './components/TextArea';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'textArea',
  pluginComponent: TextArea,
});
